import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=173ad7b6&scoped=true&"
import script from "./MyModal.vue?vue&type=script&lang=js&"
export * from "./MyModal.vue?vue&type=script&lang=js&"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=173ad7b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ad7b6",
  null
  
)

export default component.exports